import Vue from 'vue'
import Vuex from 'vuex'

// import example from './module-example'
import auth from './Auth'
import tracks from './Tracks'
import events from './Events'
import user from './User'
import registration from './Registration'
import miscellaneous from './Miscellaneous'
import coachingblock from './CoachingBlock'
import coachingTrack from './CoachingTrack'
import home from './Home'
import groups from './Groups'
import notification from './Notification'
import dashboard from './Coach/Dashboard'
import CoachingTracks from './Coach/CoachingTracks'
import DropInSessions from './Coach/DropInSessions'
import CtDashboard from './Coach/CtDashboard'
import ImpactSurveyResults from './Coach/ImpactSurveyResults'
import DsDashboard from './Coach/DsDashboard'
import CoachingEngagement from './Coach/CoachingEngagement'
import UpcomingSessions from './Coach/UpcomingSessions'
import Waitlist from './Waitlist'







Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */
let store = null
export default function( /* { ssrContext } */ ) {
    const Store = new Vuex.Store({
        modules: {
            auth,
            tracks,
            events,
            user,
            registration,
            miscellaneous,
            coachingblock,
            coachingTrack,
            home,
            groups,
            notification,
            dashboard,
            CoachingTracks,
            DropInSessions,
            CtDashboard,
            ImpactSurveyResults,
            DsDashboard,
            CoachingEngagement,
            UpcomingSessions,
            Waitlist,
        },

        // enable strict mode (adds overhead!)
        // for dev mode only
        strict: process.env.DEBUGGING
    })

    store = Store
    return Store
}

export { store }